import useSwitchState from '@anm/hooks/useSwitchState';
import noop from 'lodash/fp/noop';
import { useCallback, useEffect, FC } from 'react';

import useCardUpdateState from '../PricingSubscriptionContent/hooks/useCardUpdateState';

import SuccessAlert from './SuccessAlert';

type SuccessEditCreditCardAlertProps = {
  action: 'changed' | 'added';
  onAlertShown?: () => void;
};

export const SuccessEditCreditCardAlert: FC<SuccessEditCreditCardAlertProps> = ({
  action,
  onAlertShown = noop
}) => {
  const updateCardData = useCardUpdateState();
  const [isAlertShown, showAlert, closeAlert] = useSwitchState();

  const handleShowAlert = useCallback(() => {
    showAlert();
    onAlertShown();
  }, []);

  useEffect(() => {
    updateCardData ? handleShowAlert() : closeAlert();
  }, [!!updateCardData]);

  return (
    <>
      {isAlertShown && (
        <SuccessAlert
          alertMessage={`Your credit card was successfully ${action}!`}
          onClose={closeAlert}
        />
      )}
    </>
  );
};

export default SuccessEditCreditCardAlert;
